import { defineMessages } from 'react-intl';

export const scope = 'cb.containers.AdminPanel.BlogManager';

export default defineMessages({
  pageHeadingText: {
    id: `${scope}.pageHeadingText`,
    defaultMessage: 'Blog Manager',
  },
});